const map = {
  // 价格中心
  SalesSuggestRetailPriceDetail: () => import('@/views/priceSystem/SalesSuggestRetailPrice/Detail.vue'), // 建议零售价
  SalesSuggestRetailPriceRecord: () => import('@/views/priceSystem/SalesSuggestRetailPrice/SalesSuggestRetailPriceRecord.vue'), // 建议零售价明细查询
  RetailPriceRecord: () => import('@/views/priceSystem/SalesRetailPrice/RetailPriceRecord.vue'), // 零售价查询
  SalesRetailPriceDetail: () => import('@/views/priceSystem/SalesRetailPrice/Detail.vue'), // 零售
  SalesRetailPriceRecord: () => import('@/views/priceSystem/SalesRetailPrice/SalesRetailPriceRecord.vue'), // 零售价明细查询
  RetailPriceWarningDetail: () => import('@/views/priceSystem/RetailPriceWarning/Detail.vue'), // 预警价
  RetailPriceWarningRecord: () => import('@/views/priceSystem/RetailPriceWarning/RetailPriceWarningRecord.vue'), // 预警价查询
  DaboClassWarningDetail: () => import('@/views/priceSystem/DaboClassWarning/Detail.vue'), // 大博类预警价
  DaboClassWarningRecord: () => import('@/views/priceSystem/DaboClassWarning/DaboClassWarningRecord.vue'), // 大博类预警价查询
  // 客户分类，客户等级
  SalesCustomerLevel: () => import('@/views/priceSystem/SalesCustomerLevel/index.vue'), // 客户分类，客户等级
  SalesCustomerCategory: () => import('@/views/priceSystem/SalesCustomerCategory/index.vue'),
  // 商品可售设置
  SalesCanSellerGood: () => import('@/views/priceSystem/SalesCanSellerGood/Detail.vue'), // 商品可售设置
  // 品牌折扣
  SalesBrandDiscount: () => import('@/views/priceSystem/SalesBrandDiscount/Detail.vue'), // 品牌折扣
  SalesBrandDiscountRecord: () => import('@/views/priceSystem/SalesBrandDiscount/SalesBrandDiscountRecord.vue'), // 品牌折扣查询
  // 商品供货价
  SalesGoodsSupplyPrice: () => import('@/views/priceSystem/SalesGoodsSupplyPrice/Detail.vue'), // 商品供货价
  SalesGoodsSupplyPriceRecord: () => import('@/views/priceSystem/SalesGoodsSupplyPrice/SalesGoodsSupplyPriceRecord.vue'), // 商品供货价明细查询
  // 客户类型
  FxSellerModule: () => import('@/views/priceSystem/FxSellerModule/Detail.vue'), // 客户类型
  // 供货价销售
  SalesGoodsSupplySearch: () => import('@/views/priceSystem/SalesGoodsSupplyPrice/GoodsSupplyPriceRecord'), // 供货价销售
  // 促销价格
  SalesPromoteActivity: () => import('@/views/priceSystem/SalesPromoteActivity/Detail.vue'), // 促销价格
  // 促销管理
  SalesPromoteActivityRecord: () => import('@/views/priceSystem/SalesPromoteActivity/SalesPromoteActivityRecord.vue'), // 促销管理
  // 订单中心
  SalesFxSellerOrder: () => import('@/views/priceSystem/SalesFxSellerOrder/index.vue'), // 订单中心
  SalesFxSellerOrderDetail: () => import('@/views/priceSystem/SalesFxSellerOrder/Detail.vue'), // 订单中心
  // 售后单管理
  SalesFxRefundOrderList: () => import('@/views/priceSystem/SalesFxRefundOrder/index.vue'), // 售后单管理
  SalesFxRefundOrderDetail: () => import('@/views/priceSystem/SalesFxRefundOrder/Detail.vue'), // 售后单管理
  // 销售目标设置
  SalesCustomerRebateTargetDetail: () => import('@/views/priceSystem/SalesCustomerRebateTarget/Detail.vue'),
  // 返利
  SalesCustomerRebatePolicyDetail: () => import('@/views/priceSystem/SalesCustomerRebatePolicy/Detail.vue'),
  // 返利申请
  SalesCustomerRebateApplicationDetail: () => import('@/views/priceSystem/SalesCustomerRebateApplication/Detail.vue'),
  SalesCustomerRebateApplicationRecord: () => import('@/views/priceSystem/SalesCustomerRebateApplication/SalesCustomerRebateApplicationRecord.vue'),
  // 销售资源项查询
  SalesResourceQuotaList: () => import('@/views/priceSystem/SalesResourceQuota/index.vue'),
  SalesResourceQuotaDetail: () => import('@/views/priceSystem/SalesResourceQuota/Detail.vue'),
  SalesFxOriginalCurrencyAmountList: () => import('@/views/priceSystem/SalesFxOriginalCurrencyAmount/index.vue'),
  SalesFxOriginalCurrencyAmountDetail: () => import('@/views/priceSystem/SalesFxOriginalCurrencyAmount/Detail.vue'),
  WarningStrategyConfigDetail: () => import('@/views/priceSystem/WarningStrategyConfig/Detail.vue'),
  WarningStrategyConfigList: () => import('@/views/priceSystem/WarningStrategyConfig/index.vue'),
  SalesCanSellerGoodList: () => import('@/views/priceSystem/SalesCanSellerGood/index.vue'),
  SalesCustomerRebateApplicationList: () => import('@/views/priceSystem/SalesCustomerRebateApplication/index.vue'),
  SalesGoodsSupplyPriceList: () => import('@/views/priceSystem/SalesGoodsSupplyPrice/index.vue'),
  // 客户分类供货价
  SalesCustomerCategoryGoodsSupplyPriceList: () => import('@/views/priceSystem/SalesCustomerCategoryGoodsSupplyPrice/index.vue'),
  SalesCustomerCategoryGoodsSupplyPriceDetail: () => import('@/views/priceSystem/SalesCustomerCategoryGoodsSupplyPrice/Detail.vue')
  // SalesCustomerCategoryGoodsSupplyPriceRecord: () => import('@/views/priceSystem/SalesCustomerCategoryGoodsSupplyPrice/SalesCustomerCategoryGoodsSupplyPriceRecord.vue'),
  // SalesCustomerCategoryGoodsSupplyPriceRecord: () => import('@/views/priceSystem/SalesCustomerCategoryGoodsSupplyPrice/SalesCustomerCategoryGoodsSupplyPriceRecord.vue'),
}

export default map
